module.exports = __webpack_public_path__ + "assets/img/icon7-menu.5e9ec939.svg";